export enum SettingsActionTypes {
    SETTINGS_APP_ADD = '@settings/SETTINGS_APP_ADD',
    SETTINGS_APP_ADD_SUCCESS = '@settings/SETTINGS_APP_ADD_SUCCESS',
    SETTINGS_APP_ADD_ERROR = '@settings/SETTINGS_APP_ADD_ERROR',

    SETTINGS_APP_LIST = '@settings/SETTINGS_APP_LIST',
    SETTINGS_APP_LIST_SUCCESS = '@settings/SETTINGS_APP_LIST_SUCCESS',
    SETTINGS_APP_LIST_ERROR = '@settings/SETTINGS_APP_LIST_ERROR',

    SETTINGS_APP_UPDATE_FORCE = '@settings/SETTINGS_APP_UPDATE_FORCE',
    SETTINGS_APP_UPDATE_FORCE_SUCCESS = '@settings/SETTINGS_APP_UPDATE_FORCE_SUCCESS',
    SETTINGS_APP_UPDATE_FORCE_ERROR = '@settings/SETTINGS_APP_UPDATE_FORCE_ERROR',

    SETTINGS_APP_DELETE = '@settings/SETTINGS_APP_DELETE',
    SETTINGS_APP_DELETE_SUCCESS = '@settings/SETTINGS_APP_DELETE_SUCCESS',
    SETTINGS_APP_DELETE_ERROR = '@settings/SETTINGS_APP_DELETE_ERROR',
}
